import { Box } from "@mui/material";
import { styles } from "./menu.style";
import TutorialButton from "./tutorialButton";
import CreditStatusButton from "./creditStatusButton";
import NotificationButton from "./notificationButton";
import HistoryDropdown from "../results_reports/HistoryDropdown";
import UserButton from "./userButton";

const MenuRow = ({
  setShowTutorial,
  handleCreditClick,
  credits,
  creditAnchorEl,
  handleCreditClose,
  handleNotificationClick,
  notifications,
  notificationAnchorEl,
  handleNotificationClose,
  handleNotificationSelect,
  handleHistoryClick,
  historyAnchorEl,
  handleHistoryClose,
  history,
  handleHistorySelect,
  handleUserMenuOpen,
  handleUserMenuClose,
  userMenuAnchor,
  handleProfileClick,
  handleLogout,
}) => {
  return (
    <Box sx={styles.toolbarRight}>
      <TutorialButton setShowTutorial={setShowTutorial} />
      <CreditStatusButton
        handleCreditClick={handleCreditClick}
        credits={credits}
        creditAnchorEl={creditAnchorEl}
        handleCreditClose={handleCreditClose}
      />
      <NotificationButton
        handleNotificationClick={handleNotificationClick}
        notifications={notifications}
        notificationAnchorEl={notificationAnchorEl}
        handleNotificationClose={handleNotificationClose}
        handleNotificationSelect={handleNotificationSelect}
      />
      <HistoryDropdown
        handleHistoryClick={handleHistoryClick}
        historyAnchorEl={historyAnchorEl}
        handleHistoryClose={handleHistoryClose}
        history={history}
        handleHistorySelect={handleHistorySelect}
      />
      <UserButton
        handleUserMenuOpen={handleUserMenuOpen}
        handleUserMenuClose={handleUserMenuClose}
        userMenuAnchor={userMenuAnchor}
        handleProfileClick={handleProfileClick}
        handleLogout={handleLogout}
      />
    </Box>
  );
};

export default MenuRow;
